<!-- 会员福利社 -->
<template>
  <div class="vipWelfare">
    <publicHeader :pageTitle="pageTitle" isWhite="true"></publicHeader>
    <div class="zhanwei"></div>
    <div class="couponsList">
      <div class="couponItem" v-for="(item, index) in coupons" :key="index">
        <div class="leftInfo" @click="gotoDetail(item.actId)">
          <div class="couponPrice">
            <div class="num"><span>￥</span>{{ item.money }}</div>
            <div class="other">
              <div class="word">优惠券</div>
              <div class="man" v-if="item.isFullDecrement === '1'">
                {{ item.useConditionShow }}
              </div>
            </div>
          </div>
          <div class="condition">{{ item.getRangeShow }}</div>
        </div>
        <div class="rightInfo" @click="gotoReceive(item.actId)">立即领取</div>
      </div>
    </div>
    <publicDialog
      :info="info"
      :title="title"
      :btn1="btn1"
      :btn2="btn2"
      @changeShow="showDialog"
      :dialogIsShow="dialogIsShow"
      v-show="dialogIsShow"
    ></publicDialog>
    <publicCouponDialog
      v-if="showCouponDialog"
      :vipCouponDialogInfo="vipCouponDialogInfo"
      :showCouponDialog="showCouponDialog"
      @changeCouponDialog="changeCouponDialog"
      @handleOpenVip="handleOpenVip"
    ></publicCouponDialog>
  </div>
</template>

<script>
import publicDialog from '../components/PublicDialog'
import publicHeader from '../components/PublicHeader'
import publicCouponDialog from '../components/publicCouponDialog.vue'
export default {
  components: { publicHeader, publicCouponDialog, publicDialog },
  data() {
    return {
      coupons: [],
      isIOS: false,
      pageTitle: '',
      token: '',
      isHome: '',
      vipCouponDialogInfo: '',
      showCouponDialog: false,
      // dialog的提示内容
      dialogIsShow: false,
      info: '',
      title: '提示',
      btn1: '',
      btn2: '我知道了'
    }
  },
  created() {
    this.getToken()
    this.isHome = this.getcommit('isHome')
    this.isIOS = this.$CONFIG.isIOS
    console.log(this.isIOS)
    document.title = '会员福利社'
    this.pageTitle = '会员福利社'
    this.getCouponsList()
  },
  methods: {
    // 获取url上的信息
    getcommit(name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || ['', ''])[1].replace(/\+/g, '%20')
        ) || false
      )
    },
    // 获取token
    getToken() {
      if (this.$CONFIG.isVerify && this.isIOS) {
        this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
      } else {
        this.token = this.getcommit('token') || ''
      }
      console.log(this.token)
    },
    // 获取会员优惠券列表
    getCouponsList() {
      let params = {
        token: this.token,
        statistics: this.$CONFIG.statistics
      }
      this.$vipapi.getBenefits(params).then((res) => {
        console.log(res.data.data)
        this.coupons = res.data.data
      })
    },
    // 跳转会员福利详情页
    gotoDetail(id) {
      // 未登录
      if (!this.token) {
        this.phoneLogin()
      } else {
        if (this.isHome) {
          this.$router.push(
            `/vipcoupon?id=${id}&token=${this.token}&fromh5=1&back=1&isHome=true`
          )
        } else {
          this.$router.push(
            `/vipcoupon?id=${id}&token=${this.token}&fromh5=1&back=1`
          )
        }
      }
    },
    // 点击立即领取
    gotoReceive(id) {
      // 未登录
      if (!this.token) {
        this.phoneLogin()
      } else {
        let params = `actId=${id}&token=${this.token}&statistics=${this.$CONFIG.statistics}`
        this.$vipapi.receiveCoupon(params).then((res) => {
          console.log(res)
          // 不满足条件
          if (res.data.status === '201') {
            // 20210803雪龙需求，不满足条件弹弹窗
            this.vipCouponDialogInfo = {
              num: res.data.data.vipList.length, // 1单个会员 >1多个会员
              vipList: res.data.data.vipList
            }
            this.changeCouponDialog(true)
          } else {
            this.info = res.data.msg
            this.showDialog(true)
          }
        })
      }
    },
    // 显示弹窗
    showDialog(visible) {
      this.dialogIsShow = visible
    },
    // 显示优惠券不满足需开通会员弹窗
    changeCouponDialog(visible) {
      this.showCouponDialog = visible
    },
    handleOpenVip(id) {
      if (this.isIOS) {
        this.$router.push(
          `/vipiospay?id=${id}&type=1&token=${this.token}&statictics=${this.$CONFIG.statistics}`
        )
      } else {
        this.$router.push(
          `/vippay?id=${id}&type=1&token=${this.token}&statictics=${this.$CONFIG.statistics}`
        )
      }
    },
    // 两端的登录方法
    phoneLogin() {
      // 安卓登录
      try {
        window.LiveAppJS.login()
      } catch (e) {
        console.log('error')
      }
      // IOS登录
      try {
        window.webkit.messageHandlers.isnotlogin.postMessage('login')
      } catch (e) {
        console.log('error')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.vipWelfare {
  .couponsList {
    padding: 0.3rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .couponItem {
      width: 3.35rem;
      height: 1.72rem;
      margin-bottom: 0.2rem;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      border-radius: 0.1rem;
      background: url('https://images.zhibo.tv/2020/1106/couponbg1.png')
        no-repeat;
      background-size: 100%;

      .leftInfo {
        flex: 1;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        padding: 0 0.2rem;

        .couponPrice {
          display: flex;
          justify-content: center;
          align-items: center;

          .num {
            margin-right: 0.06rem;
            font-size: 0.8rem;
            font-family: BebasNeue;
            color: #ff543a;

            span {
              font-size: 0.24rem;
              font-family: PingFang-SC-Regular, PingFang-SC;
              font-weight: 400;
            }
          }

          .other {
            .word {
              font-size: 0.2rem;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #613f25;
            }

            .man {
              font-size: 0.2rem;
              font-family: PingFang-SC-Regular, PingFang-SC;
              font-weight: 400;
              color: #613f25;
            }
          }
        }

        .condition {
          font-size: 0.2rem;
          font-family: PingFang-SC-Regular, PingFang-SC;
          font-weight: 400;
          color: #613f25;

          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
      }

      .rightInfo {
        width: 0.52rem;
        padding: 0.3rem 0.14rem;
        position: relative;
        box-sizing: border-box;
        font-size: 0.24rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #613f25;
        line-height: 0.28rem;
      }
    }
  }
}
</style>
